import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';

import SeachResultCard from './search-result-card.component';
import NoData from "../../no-data/no-data.component";
//styles images and  icons  
import FilterLogo from './images/filter.svg';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import Pagination from '../../pagination/pagination.component';
import DoneIcon from '@material-ui/icons/Done';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {Container, Row, Col,
    InputGroup, FormControl, Form, Button } from 'react-bootstrap';
import { Chip , Checkbox , TextField} from '@material-ui/core';
import noDataImg from './images/noDataSearch.svg'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" className="text-orange"/>;

// this component represents search results component

class SearchResults extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterBy: 'Latest'
        }
        this.toggleClick = this.toggleClick.bind(this);
    }
    toggleFilter = () => {
        if (this.state.filterBy === 'Latest') {
            this.setState({ ...this.state, filterBy: 'Newest' })
        } else {
            this.setState({ ...this.state, filterBy: 'Latest' })
        }
    }
    authorization = () => {
        const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
        const uri = 'https://spreago.black-squares.com/graphql';
        const apolloFetch = createApolloFetch({ uri });
        apolloFetch.use(({ request, options }, next) => {
            if (!options.headers) {
                options.headers = {};  // Create the headers object if needed.
            }
            options.headers['authorization'] = `Bearer ${token}`;

            next();
        });
        return apolloFetch;
    }
    componentWillMount() {
        if(this.props.location.state){
            this.SearchQuery(this.props.location.state);
            this.setState({...this.state , word : this.props.location.state})
        }
        const apolloFetch = this.authorization();
        //handle fetch specialities and tags dropdown   
        //get specialites
        // apolloFetch({
        //     query:
        //         `query{
        //     specialities{
        //         id
        //         context
        //         name
        //         name_en
        //         name_ar
        //         created_at
        //         updated_at
                
        //         }
        //     }
        // `,
        // }).then(res => {
        //     if (res.data.specialities) {
        //         this.setState({ ...this.state, specialities: res.data.specialities });
        //     }
        // });
        //get job types
        apolloFetch({
            query:
                `query{
                    jobTypes{
                        id
                        name
                        name_en
                        name_ar
                    }
                    }
            `,
        }).then(res => {
            if (res.data.jobTypes) {
                this.setState({ ...this.state, jobTypes: res.data.jobTypes });
            }
        });
        //get job types
        apolloFetch({
            query:
                ` query{
                  JobLevelOfExperienceTypes{
                    id
                    context
                    name
                    name_en
                    name_ar
                  }
                }
            `,
        }).then(res => {
            if (res.data.JobLevelOfExperienceTypes) {
                this.setState({ ...this.state, experiences: res.data.JobLevelOfExperienceTypes });
            }
        });

        // get time date
        apolloFetch({
            query:
                ` query{
                  timeForSearchsForWeb{
                    DateTime
                    title
                  }
                }
            `,
        }).then(res => {
            if (res.data.timeForSearchsForWeb) {
                this.setState({ ...this.state, times: res.data.timeForSearchsForWeb });
            }
        });
    }
    componentWillReceiveProps(currentProps, nextProops) {
        if(currentProps.location.state){
            this.SearchQuery(currentProps.location.state);
        }
    }
    SearchQuery = (word) => {
        const apolloFetch = this.authorization();
        if(word){
            this.setState({...this.state , word : word});
        }
        // search query
        apolloFetch({
            query:
                `query($word : [ShortText!] $job_type_id : [Int] $job_level_of_experience_type_id : [Int]
                    $currency_type_id : [Int] $company_industry_type_id : [Int] 
                     $after_create_at : DateTime
                  ){
                      jobSearch(Inputs: {
                          word : $word
                          job_type_id : $job_type_id
                          job_level_of_experience_type_id :$job_level_of_experience_type_id
                          currency_type_id : $currency_type_id
                          company_industry_type_id : $company_industry_type_id
                          after_create_at : $after_create_at
                          }
                      , first : 10000){
                      data{
                          id
                          job_status{id}
                          job_type{id}
                          job_level_of_experience_type{id}
                        
                          title
                          brif
                        salary{
                          salary_from
                          salary_to
                          currency_type{id}
                        }
                          if_user_apply
                          if_user_save
                          applications_count 
                          questions{
                          id
                          title
                          mandatory
                          bio{
                              id
                          }
                          video{
                              id
                              url
                          }
                          }
                          company{
                              name 
                              website_url 
                              description 
                              logo{
                                  url
                                  }
                               }
                          applications_count
                          created_at
                          Auth_applications{id }
                      }
                  }
              }
            `, variables: {
                word: word ? word : this.state.word && this.state.word ,
                job_type_id: this.state.jobType?.id && this.state.jobType.id ,
                job_level_of_experience_type_id: this.state.experience?.id && this.state.experience.id,
                currency_type_id: this.state.currency && this.state.currency?.id,
                company_industry_type_id: this.state.industry && this.state.industry?.id,
                after_create_at: this.state.time && this.state.time?.DateTime,
            }
        }).then(res => {
            console.log(res);
            if (res.data.jobSearch.data) {
                this.setState({ ...this.state, data: res.data.jobSearch.data });
            }
        }).catch(err=>console.log(err));
    }
    handleSearch = (e) => {
        this.SearchQuery()
    }
    toggleClick = () => {
        let jobTypeInput  =  document.querySelector('.jobTypeSelect .MuiAutocomplete-clearIndicatorDirty');
        let experienceInput  =  document.querySelector('.experienceSelect .MuiAutocomplete-clearIndicatorDirty');

        this.setState({...this.state , jobType : '' , experience : ''})

        document.querySelector('.other-filters').classList.toggle('d-none');

        if (jobTypeInput){
            jobTypeInput.click();
        }
        if (experienceInput){
            experienceInput.click();
        }
    }
    handleKeyUp = (e) => {
        this.setState({...this.state , word : e.target.value} , ()=>  this.SearchQuery());
        // this.handleEnter(e);
        // this.SearchQuery();
    }
    handleEnter = (e) => {
        if (e.keyCode === 13) {
            this.SearchQuery()
          }
    }
    handleSelect = prop => event => {
         let item = this.state[prop].filter(x=> x.name === event.target.value || x.title === event.target.value);
         let title = prop.slice(0, -1);
         this.setState({...this.state , [title] : item[0]},()=>this.SearchQuery());
    }
    handleDelete = prop => event => {
        this.setState({...this.state , [prop] : ''})
      }
    render() {
        // if(!this.state.specialities || !this.state.times || !this.state.jobTypes || !this.state.experiences)
        if( !this.state.times || !this.state.jobTypes || !this.state.experiences){
            return (
                <Container  className="pt-5 pb-4">
                    <Row className="w-100">
                        <Skeleton variant="text" width="100%" height={60}/>
                        <Skeleton variant="rect" width="100%" height={240} />
                    </Row>
                </Container>
            )
        }
        return (
            <Container className="pt-5 pb-4">
                {/* <Row>
                    <Col md={6} xs={12} className="text-dark pt-3">
                        <h4>UX UI Design Jobs</h4>
                        <p>We have 177 active jobs. apply now to get hired</p>
                    </Col>
                </Row> */}
                <Row >
                    <Col md={5} xs={12} className="p-1">
                        <InputGroup className="outline-grey" size="md">
                            <FormControl  
                                defaultValue={this.state.word && this.state.word}  
                                onKeyUp={this.handleKeyUp}
                            />
                            <InputGroup.Append 
                                style={{cursor : 'pointer'}}  
                                onClick={this.handleSearch} 
                                className="bg-lightgrey text-dark"
                            >
                                <InputGroup.Text>Search</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                    </Col>
                    {/* <Col md={3} xs={5} className="p-1">
                        <Autocomplete
                            size="small"
                            className="w-100 text-dark"
                            defaultValue={this.state.specialitie && this.state.specialitie.id}
                            options={this.state.specialities && this.state.specialities}
                            getOptionLabel={(option) => option.name}
                            onSelect={this.handleSelect('specialities')}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 0 ,marginLeft : 0}}
                                        checked={selected}
                                        id={option.id}
                                    />
                                    {option.name}
                                </React.Fragment>
                            )}
                            renderInput={(params) => (
                                <TextField  {...params} variant="outlined" className="m-0 p-0" label="Specaility" />
                            )}
                        />
                    </Col>
                    */}
                       <Col md={3} xs={5} className="p-1 ">
                        <Autocomplete
                            size="small"
                            id="jobTypeSelect"
                            clearOnEscape={true}
                            className="w-100 text-dark jobTypeSelect"
                            defaultValue={this.state.jobType && this.state.jobType?.id}
                            options={this.state.jobTypes && this.state.jobTypes}
                            getOptionLabel={(option) => option.name}
                            onSelect={this.handleSelect('jobTypes')}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 0 ,marginLeft : 0}}
                                        checked={selected}
                                    />
                                    {option.name}
                                </React.Fragment>
                            )}
                            renderInput={(params) => (
                                <TextField  {...params} variant="outlined" label="Job Type" />
                            )}
                        />
                    </Col>
                   
                    <Col md={3} xs={5} className="p-1">
                        <Autocomplete
                            size="small"
                            className="w-100 text-dark"
                            defaultValue={this.state.time && this.state.time.title}
                            options={this.state.times && this.state.times}
                            getOptionLabel={(option) => option.title}
                            onSelect={this.handleSelect('times')}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 0 ,marginLeft : 0}}
                                        checked={selected}
                                    />
                                    {option.title}
                                </React.Fragment>
                            )}
                            renderInput={(params) => (
                                <TextField  {...params} variant="outlined" label="Date Posted" />
                            )}
                            />
                    </Col>
                    <Col md={1} xs={2} className="p-1">
                        <Button
                            className="outline-grey p-1 pl-2 pr-2 w-100"
                            onClick={this.toggleClick}>
                            <img src={FilterLogo} alt="Filter logo" />
                        </Button>
                    </Col>
                </Row>
                <Row className="other-filters d-none">
                 
                    <Col md={3} xs={6} className="p-1 pt-2">
                        <Autocomplete
                                size="small"
                                className="w-100 text-dark experienceSelect"
                                defaultValue={this.state.experience && this.state.experience?.id}
                                options={this.state.experiences && this.state.experiences}
                                getOptionLabel={(option) => option.name}
                                onSelect={this.handleSelect('experiences')}
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 0 ,marginLeft : 0}}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </React.Fragment>
                                )}
                                renderInput={(params) => (
                                    <TextField  {...params} variant="outlined" label="Years Of Experience" />
                                )}
                        />
                    </Col>
                </Row>
                {/* tags */}
                <Row classname="p-0">
                    {this.state.word && 
                        <div className="p-1">
                                <Chip label={this.state.word}  />
                        </div>
                    }
                    {this.state.specialitie && 
                        <div className="p-1">
                                <Chip label={this.state.specialitie.name} />
                        </div>
                    }
                    {this.state.jobType && 
                        <div className="p-1">
                                <Chip label={this.state.jobType.name}  />
                        </div>
                    }
                    {this.state.time && 
                        <div className="p-1">
                                <Chip label={this.state.time.title}  />
                        </div>
                    }
                    {this.state.experience && 
                        <div className="p-1">
                                <Chip label={this.state.experience.name} />
                        </div>
                    }
                </Row>
                {(this.state.data)?
                (this.state.data.length > 0)?
                <Row elevation={3} className="border rounded mt-4" >
                        <Row className="bg-lightgrey  p-3 m-0 w-100" style={{ borderBottom: '1px solid #f2f2f2' }}>
                            <Col xs={6} className="text-left p-0">
                                Search results
                            </Col>
                            <Col className="text-right p-0" xs={6}>
                                <p className="bold mb-0"
                                >Sort by:
                                    <Link className="text-orange" to=''
                                        onClick={e => {
                                            e.preventDefault();
                                            this.setState({ ...this.state, data: this.state.data.reverse() })
                                            this.toggleFilter();
                                        }}> {this.state.filterBy}</Link> <ExpandMoreIcon /></p>
                            </Col>
                        </Row>
                        <Row className=" m-0 w-100" >
                            <Pagination card={this.state.data}>
                                <SeachResultCard />
                            </Pagination>
                        </Row>
                </Row>
                :   
                <NoData  
                    img={noDataImg} 
                    title="Not Found" 
                    description="there is no result for your search, try to search with different key."
                />
                :
                <NoData  
                    img={noDataImg} 
                />
                }
            </Container>
        )
    }
}

export default withRouter(SearchResults);